<template>
  <div class="container bg-hui">
    <div class="bg_bai">
      <div class="box-jj iconfont icon-tishi" @click="clickCouponInstructions">
        优惠券使用说明
      </div>
    </div>
    <div class="p16">
      <div class="ooupon-dl" v-if="lists.length">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <van-list
            v-model="isLoading"
            :finished="finished"
            :immediate-check="false"
            finished-text=""
            @load="onLoad"
            :offset="10"
          >
            <dl
              :class="[{ active: item.id == idSelected }]"
              v-for="(item, index) in lists"
              :key="index"
              @click="chooseCur(index, item.id, item.couponMsg.name)"
            >
              <dt>
                <div class="font1" v-if="item.couponMsg.couponType==2">
                  <span>{{ item.couponMsg.faceValue | calcPriceFun }}</span
                  >元
                  <p v-if="item.couponMsg.moneyLimit==0">立减</p>
                  <p v-if="item.couponMsg.moneyLimit==1">满{{item.couponMsg.money | calcPriceFun}}元可用</p>
                </div>
                 <div class="font1" v-if="item.couponMsg.couponType==1">
                  <span>{{ item.couponMsg.discount }}</span
                  >折
                  <p v-if="item.couponMsg.moneyLimit==1">满{{item.couponMsg.money | calcPriceFun}}元可用</p>
                </div>
                <div class="font2">
                  <p class="name">
                    <b>{{ item.couponMsg.name }}</b
                    ><span class="tips">代驾</span>
                  </p>
                  有效期至：{{ item.couponMsg.endTime | formatDate }}
                </div>
              </dt>
              <dd>{{item.couponMsg.cityLimitStr?item.couponMsg.cityLimitStr:'全国可用'}} · {{item.couponMsg.timeRangesStr?item.couponMsg.timeRangesStr:'不限时段'}}</dd>
            </dl>
          </van-list>
        </van-pull-refresh>
      </div>
      <no-data :tips="tips" v-else></no-data>
    </div>
    <div class="btn_box">
      <div class="confirm-box" v-if="lists.length">
        <span @click="openWindow()" v-if="orderId">确定</span>
        <span @click="goWindow()" v-else>兑换代驾券</span>
      </div>
    </div>
  </div>
</template>

<script>
import NoData from "../../components/noData";
import util from "../../utils/util";
import { getUnUseCoupon } from "@/apis/order/order";
import mobileType from "../../utils/mobileType";
import wx from "weixin-js-sdk";
export default {
  components: { NoData },
  data() {
    return {
      isLoading: false,
      finished: false,
      currentPage: 1, //请求第几页
      pageSize: 10000, //每页请求的数量
      count: 0, //总共的数据条数
      lists: [],
      tips: "暂时没有优惠券哦～",
      idSelected: 0,
      id: null,
      data: {},
      params: {},
      orderId: null,
    };
  },
  created() {
    //Vue的方法给原生调用，则需要把方法挂在Window下面
    window.getDataFromNative = this.getDataFromNative;
  },
  mounted() {
    let data = decodeURIComponent(this.$route.query.data);
    this.data = JSON.parse(data);

    if (this.data.platform && this.data.platform == 3) {
      this.params = Object.assign({}, this.params, this.data);
      let areaCode = this.params.areaCode;
      let cityCode = +(areaCode.slice(0, 4) + "00");
      this.params.cityCode = cityCode;
      this.idSelected = this.params.couponId;
      this.orderId = this.params.orderId;
      console.log(this.params);
      this.getInfo();
    } else {
      this.idSelected = this.data.couponId;
      this.orderId = this.data.orderId;
      this.getUserInfoFromApp();
    }
  },
  filters: {
    calcPriceFun(val) {
      return util.calcPriceL(val);
    },
    formatDate(val) {
      return util.timestampToYMD(val);
    },
  },
  methods: {
    getUserInfoFromApp() {
      let params = {
        methodName: "getDataFromNative", //定义与原生的方法名(固定)
        type: 1, //业务类型(固定)
      };
      if (mobileType.isIOS()) {
        //vue调用iOS方法，且传值给iOS （iOS 方法名为 getDataFromVue）
        window.webkit.messageHandlers.getDataFromVue.postMessage(params);
      } else if (mobileType.isAndroid()) {
        //vue调用Android方法，且传值给Android （Android方法名为 getDataFromVue）
        window.Android.getDataFromVue(JSON.stringify(params));
      } else {
      }
    },
    getDataFromNative(params) {
      if (mobileType.isIOS()) {
        this.params = params;
      } else if (mobileType.isAndroid()) {
        this.params = JSON.parse(params);
      }
      
       let data = decodeURIComponent(this.$route.query.data);
      this.data = JSON.parse(data);
      this.idSelected = this.data.couponId;
      this.orderId = this.data.orderId;
      this.getInfo();
    },
    // 跳转优惠券说明
    clickCouponInstructions() {
      this.$router.push("/home/couponInstructions");
    },
    // 选择优惠券
    chooseCur(index, id, name) {
      if (this.orderId) {
        console.log(index, name);
        this.idSelected = id;
        this.id = id;
        this.name = name;
      }
    },
    //下拉刷新
    onRefresh() {
      setTimeout(() => {
        // this.$toast('刷新成功');
        this.isLoading = false;
        this.finished = false;
        this.currentPage = 1; //请求第几页
        this.pageSize = 10000; //每页请求的数量
        this.count = 0; //总共的数据条数
        this.lists = [];
        this.getInfo();
      }, 500);
    },

    //上拉加载
    //滚动加载时触发，list组件定义的方法
    onLoad() {
      this.currentPage++;
      this.getInfo();
    },
    // 获取数据
    async getInfo() {
      let params = {
        ...this.params,
        data: {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          cityCode: this.data.cityCode,
        },
      };
      if (this.orderId) {
        params.data.orderId = this.orderId;
      }
      params.data = JSON.stringify(params.data);
      try {
        const data = await getUnUseCoupon(params);
        if (data.code == 1 && data.data) {
          let lists = JSON.parse(data.data).body;
          this.isLoading = false;
          this.count = JSON.parse(data.data).count;
          if (lists == null || lists.length === 0) {
            // 加载结束
            this.finished = true;
            return;
          }
          // 将新数据与老数据进行合并
          this.lists = this.lists.concat(lists);
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (this.lists.length >= this.count) {
            this.finished = true;
          }
        }
      } catch (error) {}
    },
    //选择优惠券确定
    openWindow() {
      let params = {
        type: 0, //业务类型
        methodName: "getCoupon", //传给客户端标识方法名
        data: {
          title: "代驾优惠券",
          id: this.id ? this.id : this.lists[0].id,
          name: this.name ? this.name : this.lists[0].couponMsg.name,
        }, //传多个参数给原生(为对象类型)
      };
      if (this.params.platform == 3) {
        console.log(this.id ? this.id : this.lists[0].id);
        // 点击跳转小程序页面
        wx.miniProgram.postMessage({
          data: {
            couponId: this.id ? this.id : this.lists[0].id,
          },
        });
        wx.miniProgram.navigateBack({
          delta: 1,
        });
      } else {
        if (mobileType.isIOS()) {
          //vue调用iOS方法，且传值给iOS （iOS 方法名为 getDataFromVue）
          window.webkit.messageHandlers.getDataFromVue.postMessage(params);
        } else if (mobileType.isAndroid()) {
          //vue调用Android方法，且传值给Android （Android方法名为 getDataFromVue）
          window.Android.getDataFromVue(JSON.stringify(params));
        }
      }
    },
    //跳转兑换券
    goWindow() {
      this.$router.push({
        name: "exchangeUniversal",
        query: {
          params: JSON.stringify(this.params),
          isFrom: 'appMini'
        },
      });
    },
  },
};
</script>
<style scoped lang="less">
.container {
  background: rgb(245, 245, 245);
}
.box-jj {
  padding: 0.75rem 1.25rem;
  font-size: 0.875rem;
  color: #666666;
  line-height: 1.25rem;
}

.icon-tishi:before {
  font-size: 1.25rem;
  position: relative;
  top: 2px;
  margin-right: 0.75rem;
}

.ooupon-dl {
  .active {
    border: 1px solid #e60012;
  }
  dl {
    box-shadow: 0px 0px 0.5rem 0px rgba(0, 0, 0, 0.06);
    border-radius: 0.25rem;
    font-size: 0.75rem;
    color: #666666;
    line-height: 1.0625rem;
    overflow: hidden;
    box-sizing: border-box;
    background: rgba(245, 245, 245, 0.5);
    background-size: 100% auto;
    min-height: 7.5rem;
    margin-bottom: 0.75rem;

    dt {
      padding-bottom: 1.375rem;
      background: #fff;
      .font1 {
        display: inline-block;
        /*float: left;*/
        width: 6.75rem;
        color: #e60012;
        font-size: 0.9375rem;
        margin: 1.375rem 0 0 0;
        border-right: 2px dashed #ececec;
        vertical-align: top;
        text-align: center;

        span {
          font-size: 2.25rem;
          line-height: 3.125rem;
        }

        p {
          font-size: 0.75rem;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 1.0625rem;
        }
      }

      .font2 {
        display: inline-block;
        margin-left: 1.5rem;
        font-size: 0.75rem;
        color: #666666;
      }
      .name {
        padding: 1.625rem 0 1.0625rem 0;
        display: flex;
        align-items: center;
        .tips {
          display: inline-block;
          text-align: center;
          width: 3rem;
          height: 1.25rem;
          background: rgba(230, 0, 18, 0.1);
          border-radius: 0.625rem;
          font-size: 0.75rem;
          font-weight: 400;
          color: #e60012;
          line-height: 1.25rem;
          margin-left: 0.5rem;
        }
        b {
          max-width: 7.5rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #333333;
          line-height:1.5rem;
          font-size: 1.0625rem;
          font-weight: 600;
          color: #333333;
          line-height: 1.5rem;
          display: inline-block;
        }
      }
    }

    dd {
      padding-left: 1.5rem;
      line-height: 17px;
      color: #999;
      margin: 0.625rem 0;
    }
  }
}
.van-list {
  padding-bottom: 6rem;
}
.van-pull-refresh {
  overflow: inherit;
}
.btn_box {
  position: fixed;
  bottom: 0;
  background: rgb(245, 245, 245);
  height: 7rem;
  left: 50%;
  transform: translate(-50%, 0);
}
.confirm-box {
  margin-top: 2rem;
  width: 21.6875rem;
  height: 3rem;
  background: #252b3b;
  border-radius: 0.625rem;
  text-align: center;
  line-height: 3rem;

  color: #fff;
  font-size: 1rem;
  span {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}
</style>

